<template>
  <div>
    <b-row>
      <b-col cols="12" v-show="isLoading">
        <div class="text-center">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
      </b-col>
      <b-col v-show="!isLoading">
        <interviewSeniorMasterForm @submit="save" @closeModal="closeModal" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import interviewSeniorMasterForm from "./../forms/interviewSeniorMasterForm";
export default {
  components: {
    interviewSeniorMasterForm,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  inject: ["interviewRepository"],
  methods: {
    async save(payload, code) {
      this.isLoading = true;
      try {
        let response = await this.interviewRepository.partial_edit(
          code,
          payload
        );
        this.$notify.success(response.data.message);
        this.closeModal();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    closeModal() {
      this.$emit("modal-end-up");
    },
  },
};
</script>

<style>
</style>
